import { localizeTranslationValue, toLocale } from '@longy/common'
import { Prisma } from '@prisma-clinic/client'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const useLocale = () => {
    const { i18n } = useTranslation()
    const locale = toLocale(i18n.language)

    const getLocalizedValue = useCallback(
        (someField: Prisma.JsonValue): string => localizeTranslationValue(someField, locale),
        [locale],
    )

    return {
        locale,
        getLocalizedValue,
    }
}
